class DiscountPopup {
  constructor() {
    console.log('DiscountPopup initialized');

    this.popup = document.getElementById('discount-popup-modal');
    if (!this.popup) return;

    this.overlay = document.querySelector('.discount-popup-modal__overlay');
    this.closeButton = document.querySelector('.discount-popup-modal__close-button');
    this.closeButtonBottom = document.querySelector('.discount-popup-modal__close-button-bottom');
    this.copyButton = document.querySelector('.copy-discount-code');
    this.discountCode = document.getElementById('discount-code-value');
    this.successMessage = document.querySelector('.success-message');

    this.popupDelay = window.theme?.popupDelay || 2;
    this.popupFrequency = window.theme?.popupFrequency || 30;

    // Make the showPopup method available globally
    window.showDiscountPopup = this.showPopup.bind(this);

    // Setup the event listeners regardless
    this.setupEventListeners();

    // Only auto-show if not coming from a share action
    // this.init();
  }

  setupEventListeners() {
    // Setup event listeners
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.hidePopup.bind(this));
    }

    // Add event listener for bottom close button
    if (this.closeButtonBottom) {
      this.closeButtonBottom.addEventListener('click', this.hidePopup.bind(this));
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', this.hidePopup.bind(this));
    }

    if (this.copyButton) {
      this.copyButton.addEventListener('click', this.copyDiscountCode.bind(this));
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hidePopup();
      }
    });
  }

  showPopup() {
    if (!this.popup) return;
    this.popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  hidePopup() {
    if (!this.popup) return;
    this.popup.style.display = 'none';
    document.body.style.overflow = '';
  }

  copyDiscountCode() {
    const code = this.discountCode.textContent;
    navigator.clipboard.writeText(code).then(() => {
      // Show success message
      this.successMessage.style.display = 'block';
      setTimeout(() => {
        this.successMessage.style.display = 'none';
      }, 3000);
    });
  }
}

// Initialize the popup on document load
document.addEventListener('DOMContentLoaded', () => {
  console.log('Document loaded');
  new DiscountPopup();
});
